import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';
import { UserAccount } from '../../../shared/models/api/user';
import { environment } from '../../../../environments/environment';


export interface PasswordUpdateResponse {
  message: string;
}
@Injectable({
  providedIn: 'root'
})
export class UserAccountApiService {
  http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getAccount(): Observable<UserAccount> {
    const params = `/users/account/me`;
    return this.http.get<UserAccount>(this.apiUrl + params)
      .pipe(map((response) => response));
  }

  updateMyPassword({
    password,
    confirmPassword,
    identityPlatformId,
  }:{
    password: string,
    confirmPassword: string,
    identityPlatformId: string,
  }): Observable<PasswordUpdateResponse> {
    const params = `/users/account/me/password`;
    return this.http.put<PasswordUpdateResponse>(this.apiUrl + params, {
      password,
      confirmPassword,
      identityPlatformId,
    })
      .pipe(map((response) => response));
  }
}
